import React, { useCallback } from 'react';
import { Carousel, useCarousel } from 'nuka-carousel';
import classNames from 'classnames';
import styles from './BenefitsList.module.scss';
import benefit1Img from '../../../../assets/images/premium-benefits/benefit-1.png';
import benefit1Img2x from '../../../../assets/images/premium-benefits/benefit-1@2x.png';
import benefit2Img from '../../../../assets/images/premium-benefits/benefit-2.png';
import benefit2Img2x from '../../../../assets/images/premium-benefits/benefit-2@2x.png';
import benefit3Img from '../../../../assets/images/premium-benefits/benefit-3.png';
import benefit3Img2x from '../../../../assets/images/premium-benefits/benefit-3@2x.png';

export const CustomDots = () => {
  const { totalPages, currentPage, goToPage } = useCarousel();

  const handleClick = useCallback(
    (index: number) => () => {
      goToPage(index);
    },
    [goToPage]
  );

  const handleKeyDown = useCallback(
    (index: number) => (e: React.KeyboardEvent<HTMLDivElement>) => {
      if (e.key === 'Enter' || e.key === ' ') {
        e.preventDefault();
        goToPage(index);
      }
    },
    [goToPage]
  );

  return (
    <div className='d-flex flex-ai-c gap-xxxs d-none@sm'>
      {[...Array(totalPages)].map((_, index) => (
        <div
          key={`dot-${index + 1}`}
          role='button'
          tabIndex={0}
          onClick={handleClick(index)}
          onKeyDown={handleKeyDown(index)}
          className={classNames(styles['nuka-carousel-dot'], {
            [styles.active]: currentPage === index,
          })}
        />
      ))}
    </div>
  );
};

const BENEFITS: Benefit[] = [
  {
    title: 'Get response up to 3X faster',
    gradient: 'primary',
    img: benefit1Img,
    img2x: benefit1Img2x,
  },
  {
    title: 'A+ solutions included for every task',
    gradient: 'secondary',
    img: benefit2Img,
    img2x: benefit2Img2x,
  },
  {
    title: 'Enjoy focusing without ads',
    gradient: 'tertiary',
    img: benefit3Img,
    img2x: benefit3Img2x,
  },
];

interface Benefit {
  title: string;
  gradient: 'primary' | 'secondary' | 'tertiary';
  img: string;
  img2x: string;
}

interface Props {
  animatedVisible?: boolean;
}

const BenefitsList: React.FC<Props> = ({ animatedVisible = false }) => (
  <Carousel
    showDots
    autoplay
    dots={<CustomDots />}
    className={styles.benefitsList}>
    {BENEFITS.map((benefit, index) => (
      <div
        key={benefit.title}
        className={classNames(styles.benefitWrapper, {
          [styles.animatedVisible]: animatedVisible,
        })}
        style={{
          animationDelay: `${(index === 0 ? 1 : index + 1) * 1}s`,
        }}>
        <div className={classNames(styles.benefit, styles[benefit.gradient])}>
          <p
            className={classNames(
              styles.title,
              'text-md text-sm@sm fw-bold c-white'
            )}>
            {benefit.title}
          </p>
          <img
            className={styles.img}
            src={benefit.img}
            alt={benefit.title}
            srcSet={`${benefit.img2x} 2x`}
          />
        </div>
      </div>
    ))}
  </Carousel>
);

export default BenefitsList;
